module.exports = "<svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>\n    Artboard 3\n  </title>\n  <path d=\"M23.498 7.53a3.596 3.596 0 0 1-2.554 1.062 3.62 3.62 0 0 1-3.611-3.626c0-1.002.404-1.909 1.058-2.565L16 0 9.027 6.905l10.07 10.07L26 10.043 23.498 7.53zM6.895 9.016L16.98 19.101 10.111 26l-2.502-2.513a3.62 3.62 0 0 0 1.057-2.564 3.618 3.618 0 0 0-3.61-3.627c-.997 0-1.9.406-2.554 1.062L0 15.845l6.895-6.829z\" fill=\"#15100C\" fill-rule=\"evenodd\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/svg/icon-26-venue.svg
// module id = 3717
// module chunks = 168707334958949